import { render, staticRenderFns } from "./DashboardNivelTensaoVisaoGeral.vue?vue&type=template&id=d240d75c&"
import script from "./DashboardNivelTensaoVisaoGeral.vue?vue&type=script&lang=js&"
export * from "./DashboardNivelTensaoVisaoGeral.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNivelTensaoVisaoGeral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCol,VRow,VSelect,VTab,VTabItem,VTabs,VTabsItems})
